import { useState } from 'react';
import { Box, Popover, SvgIcon, Theme, useMediaQuery } from '@mui/material';
import { IconDotsVertical } from '@tabler/icons-react';
import { Button } from '@atoms';
import styles from './styles';

interface ToolbarProps {
  buttons: [
    {
      onClick: () => void;
      text: string;
      icon: React.ReactNode;
      disabled: boolean;
      isLoading: boolean;
    }
  ];
}

/**
 * Toolbar actions
 * @param props - The properties of the Toolbar component.
 * @param props.buttons - An array of objects representing the actions.
 */
const Toolbar = ({ buttons }: ToolbarProps) => {
  const firstButtons = buttons.slice(0, 5);
  const moreButtons = buttons.slice(5);
  const showMoreButtons = buttons.length > 5;
  const [showPopover, setShowPopover] = useState<null | HTMLElement>(null);
  const responsive = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  /** Open more actions  */
  const handleShowMoreClick = (event: React.MouseEvent<HTMLElement>) => {
    setShowPopover(event.currentTarget);
  };
  /** Close more actions */
  const handleClose = () => {
    setShowPopover(null);
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.containerFirstButtons(responsive)}>
        {firstButtons.map((button, index) => (
          <Button
            key={index}
            customStyle={styles.button}
            onClick={button.onClick}
            text={button.text}
            startIcon={<SvgIcon>{button.icon}</SvgIcon>}
            disabled={button.disabled}
            isLoading={button?.isLoading}
          />
        ))}
      </Box>
      {showMoreButtons && (
        <>
          <Button
            customStyle={styles.button}
            onClick={handleShowMoreClick}
            text={'Más'}
            startIcon={
              <SvgIcon>
                <IconDotsVertical />
              </SvgIcon>
            }
          />
          <Popover
            open={Boolean(showPopover)}
            anchorEl={showPopover}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Box sx={styles.containerPopover}>
              {moreButtons.map((button, index) => (
                <Button
                  key={index}
                  customStyle={styles.button}
                  onClick={button.onClick}
                  text={button.text}
                  startIcon={<SvgIcon>{button.icon}</SvgIcon>}
                />
              ))}
            </Box>
          </Popover>
        </>
      )}
    </Box>
  );
};

export default Toolbar;
